import React from 'react';
import { FileText } from 'lucide-react';
import MediaPreview from './SharedMediaPreview';

interface FilePreviewerProps {
    fileName: string;
}

const FilePreviewer: React.FC<FilePreviewerProps> = ({ fileName }) => {
    // If no fileName, show placeholder immediately
    if (!fileName) {
        return (
            <div className="fallback-content w-full h-full flex flex-col items-center justify-center gap-1 text-gray-500">
                <FileText className="h-6 w-6" />
                <span className="text-xs">File Placeholder</span>
            </div>
        );
    }

    return (
        <div className="w-full h-full" style={{ overflow: 'hidden' }}>
            <MediaPreview
                fileName={fileName}
                type="file"
                className="w-full h-full"
                style={{ width: '100%', height: '100%' }}
            />
        </div>
    );
};

export default FilePreviewer;
